import { getMediaUrl } from '@/lib/media'
import { DimensionsConfig } from '@/payload-types'
import { DIMENSION_FILTERS } from '@/utilities/constant'

export type DimensionFieldConfig = {
  key: string
  label: string
  fieldType: 'text' | 'number' | 'select'
  required: boolean
}

export type FilterConfig = {
  image: string
  filters: Record<string, DimensionFieldConfig>
}

export type FilterDimensionMappingType = Record<string, Record<string, FilterConfig>>

export const transformDimensionsConfig = (
  data: DimensionsConfig['dimensions'],
): FilterDimensionMappingType => {
  return (
    data?.reduce((acc, category) => {
      acc[category.filterType] = category.filterShapes?.reduce(
        (shapeAcc, shape) => {
          shapeAcc[shape.shapes] = {
            image: getMediaUrl(shape.image) || '',

            filters:
              shape.dimensionList?.reduce((filterAcc, item) => {
                const dimension = DIMENSION_FILTERS.find(
                  (d) => d.value === item.dimension,
                )

                if (!dimension) return filterAcc

                filterAcc[item.dimension] = {
                  key: item.dimension,
                  label: dimension.label,
                  fieldType: item.fieldType,
                  required: item.required ?? false,
                }

                return filterAcc
              }, {} as Record<string, DimensionFieldConfig>) || {},
          }

          return shapeAcc
        },

        {} as Record<string, FilterConfig>,
      )

      return acc
    }, {} as FilterDimensionMappingType) || {}
  )
}
